<template>
	  <div class="fx fx-y-center">
			<div class="title fx w120 m-r-5"><p class="ask-cont"><i class="ask" v-if="isMust">*</i></p><span class="fx-fill">{{title}}</span></div>
			<div class="fx-fill">
					<input v-if="type == 'text' || type == 'tel'  || type == 'email'"
					class="input b-r-5"
					type="type"
					@change="$emit('change', currentValue)"
					v-model="currentValue"
					:maxlength="maxlength"
					:disabled="disabled"
					:placeholder="placeholderDefult"
					v-on:blur="handleBlur"
					@keyup.enter="handleKeyEnter"
					/>
					<input v-if="type == 'password'"
					class="input b-r-5"
					type="password"
					@change="$emit('change', currentValue)"
					v-model="currentValue"
					:maxlength="maxlength"
					:disabled="disabled"
					:placeholder="placeholderDefult"
					/>
					<input v-if="type == 'number'"
					class="input b-r-5"
					type="number"
					@change="$emit('change', currentValue)"
					v-model="currentValue"
					:maxlength="maxlength"
					:disabled="disabled"
					:placeholder="placeholderDefult"
					v-on:blur="handleBlur"
					@keyup.enter="handleKeyEnter"
					/>
					<textarea v-if="type == 'textarea'"
						class="edit b-r-5"
						@change="$emit('change', currentValue)"
						v-model="currentValue"
						:maxlength="maxlength"
						:placeholder="placeholderDefult"
						>
					</textarea>
			</div>
		</div>
</template>

<script>
/**
 * z-input
 * @module components/Input
 * @desc 输入框/编辑框
 * @param {String} [value] - 绑定值，支持双向绑定
 * @param {String} [type] - 输入框类型 text/password/textarea
 * @param {String} [title] - 标题
 * @param {String} [maxlength] - 限制长度
 * @param {Boolean} [isMust] - 是否是必须
 * @param {Boolean} [disabled] - 是否可编辑
 * @param {String} [placeholder] - 输入框提示
 * @example
 * <z-input v-model="value"></z-input>
 */
export default {
  name: 'z-input',
  props: {
    value: {
    		type:[String,Number],
				default: ''
    },
    type: {
	    type: String,
	    default: 'text'
	  },
    title:{
    	type:String,
			default: ''
    },
    maxlength: [Number,String],
    isMust:[Boolean,String],
    disabled: Boolean,
    placeholder:{
	    type: String,
	    default: ''
	  }
  },
  computed: {
		placeholderDefult(){
			return this.placeholder 
		},
    currentValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
  	handleBlur() {
  		this.$emit("handleBlur");
  	},
  	handleKeyEnter() {
  		this.$emit("handleKeyEnter");
  	}
  }
};
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	textarea{
		min-height: 100px;
	}
</style>


// WEBPACK FOOTER //
// Input.vue?02b77666